export enum ReturnDisbursementRecipientCapabilityStatus {
  Active = "active",
  Pending = "pending",
  Restricted = "restricted",
  Unsupported = "unsupported",
}
